import React from "react"
import PropTypes from "prop-types"
import { getPatientAge, getPatientName, getPatientMRN, getViewPatientData, getQuickSightUrl } from "../../../lib"
import { APP_TAB_PERMISSIONS } from "../../../lib/appPermissions"
import "./PatientSidebar.less"
import Grid from "../../Fhir/Grid";

export default class UMSidebar extends React.Component {
    static propTypes = {
        sidebarView: PropTypes.string,
        title: PropTypes.string,
        isSidebarOpen: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        settings: PropTypes.object.isRequired,
        selectedUser: PropTypes.object,
        onSave: PropTypes.func.isRequired,
        groups: PropTypes.array,
        permissions: PropTypes.array
    };

    static defaultProps = {
        groups: [],
        permissions: [],
        formData: {},
        rolesList: [],
        organizationList: [],
        serviceProviderList: [],
    };

    constructor(props) {
        super(props);
        this.state = {
            formData: {},
            errors: {}
        };
    }

    componentDidMount() {
        console.log("Selected User:", this.props.selectedUser);
        this.fetchRolesData();
        if (this.props.sidebarView === "userEdit" && this.props.selectedUser) {
            this.fetchOrganizationData();
            this.fetchExistingServiceProviderId();
            this.setState({
                formData: {
                    username: this.props.selectedUser.username || "",
                    email: this.props.selectedUser.email || "",
                    group: this.props.selectedUser.groups?.[0] || "",
                }
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.sidebarView === "userEdit" &&
            prevProps.selectedUser !== this.props.selectedUser
        ) {
            const selectedGroup = this.props.selectedUser?.groups
                ? this.props.selectedUser.groups[0]
                : "";

            this.setState({
                formData: {
                    group: selectedGroup
                }
            });
        }
    }

    fetchServiceProvidersData = async (orgName) => {
        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/referral/serviceProviderList?orgName=${orgName}`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });
            if (data) {
                this.setState({
                    serviceProviderList: data?.serviceProviders?.map(item => ({
                        name: `${item.provider_name} (${item?.organization_npi})`,
                        id: item?.service_provider_id
                    })) || [],
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
        }
    };

    fetchOrganizationData = async () => {
        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/referral/service-provider-organisationList`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });
            if (data) {
                this.setState({
                    organizationList: data?.organizations?.map(item => ({
                        name: item,
                        id: item
                    })) || [],
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
        }
    };

    fetchExistingServiceProviderId = async () => {
        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/referral/provider-id?username=${this.props.selectedUser?.username}`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });
            if (data) {
                this.setState(
                    (prevState) => ({
                        formData: {
                            ...prevState.formData,
                            provider: data?.serviceProviderId || ""
                        }
                    })
                )
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
        }
    };

    fetchRolesData = async () => {
        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/usermanagement/groups`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data) {
                this.setState({
                    rolesList: data,
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
        }
    };

    handleInputChange = (e) => {
        let { name, value, type, checked } = e.target;
        if (name === "roleName") {
            value = value.replace(/\s+/g, "");
        }
        if (name === "group" && value === "AgencyUser") {
            this.fetchOrganizationData();
        }
        if (name === "organization") {
            this.fetchServiceProvidersData(value);
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: type === 'checkbox' ? checked : value
            },
            errors: {
                ...prevState.errors,
                [name]: null
            }
        }));
    };

    handlePermissionChange = (permissionId) => {
        this.setState(prevState => {
            const currentPermissions = prevState.formData.permissions || [];
            const newPermissions = currentPermissions.includes(permissionId)
                ? currentPermissions.filter(id => id !== permissionId)
                : [...currentPermissions, permissionId];

            return {
                formData: {
                    ...prevState.formData,
                    permissions: newPermissions
                }
            };
        });
    };

    validateForm = () => {
        const { sidebarView } = this.props;
        const { formData } = this.state;
        const errors = {};

        if (sidebarView === 'group') {
            if (!formData.roleName || formData.roleName.trim() === '') {
                errors.roleName = 'Role Name is required';
            }
        } else if (sidebarView === 'user') {
            if (!formData.firstName || formData.firstName.trim() === '') {
                errors.firstName = 'First Name is required';
            }
            if (!formData.username || formData.username.trim() === '') {
                errors.username = 'Username is required';
            }
            if (!formData.email || formData.email.trim() === '') {
                errors.email = 'Email is required';
            } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
                errors.email = 'Email is invalid';
            }
            if (!formData.group) {
                errors.group = 'Group is required';
            }
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.props.sidebarView === 'userEdit') {
            this.props.onSave(this.state.formData, this.props.sidebarView);
        } else {
            if (this.validateForm()) {
                // console.log("Form data is valid, submitting:", this.state.formData);
                this.props.onSave(this.state.formData, this.props.sidebarView);
            }
        }
    };

    renderRoleForm = () => {
        const { formData, errors } = this.state;

        const permissions = APP_TAB_PERMISSIONS;

        return (
            <form onSubmit={this.handleSubmit}>
                {/* ROLE NAME */}
                <div className={`form-group ${errors.roleName ? 'has-error' : ''}`}>
                    <label htmlFor="roleName">Role Name <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        id="roleName"
                        name="roleName"
                        value={formData.roleName || ''}
                        onChange={this.handleInputChange}
                        placeholder="Enter role name"
                    />
                    {errors.roleName && <span className="help-block">{errors.roleName}</span>}
                </div>

                {/* SCOPES */}
                <div className="form-group">
                    <label>Scopes</label>

                    <div className="permission-list">
                        {permissions.map(permission => (
                            <div key={permission.id} className="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={(formData.scopes || []).includes(permission.id)}
                                        onChange={() => this.handleScopeChange(permission.id)}
                                    />
                                    {permission.name}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="form-group sidebar-actions">
                    <button type="submit" className="btn btn-primary">
                        <i className="fa fa-save" /> Save
                    </button>
                    <button type="button" className="btn btn-default" onClick={this.props.onClose}>
                        <i className="fa fa-times" /> Cancel
                    </button>
                </div>
            </form>
        );
    };

    handleScopeChange = (scopeId) => {
        this.setState(prevState => {
            const currentScopes = prevState.formData.scopes || [];

            const newScopes = currentScopes.includes(scopeId)
                ? currentScopes.filter(id => id !== scopeId)
                : [...currentScopes, scopeId];

            return {
                formData: {
                    ...prevState.formData,
                    scopes: newScopes
                }
            };
        });
    };


    renderUserForm = () => {
        const { formData, errors } = this.state;
        const { groups } = this.props;

        return (
            <form onSubmit={this.handleSubmit}>
                <div className="row w-100">
                    <div className="col-lg-6">
                        <div className={`form-group ${errors.firstName ? 'has-error' : ''}`}>
                            <label htmlFor="firstName">First Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="firstName"
                                name="firstName"
                                value={formData.firstName || ''}
                                onChange={this.handleInputChange}
                                placeholder="Enter First Name"
                            />
                            {errors.firstName && <span className="help-block">{errors.firstName}</span>}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className={`form-group ${errors.lastName ? 'has-error' : ''}`}>
                            <label htmlFor="lastName">Last Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="lastName"
                                name="lastName"
                                value={formData.lastName || ''}
                                onChange={this.handleInputChange}
                                placeholder="Enter Last Name"
                            />
                            {errors.lastName && <span className="help-block">{errors.lastName}</span>}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className={`form-group ${errors.username ? 'has-error' : ''}`}>
                            <label htmlFor="username">Username <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                name="username"
                                value={formData.username || ''}
                                onChange={this.handleInputChange}
                                placeholder="Enter Username"
                            />
                            {errors.username && <span className="help-block">{errors.username}</span>}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className={`form-group ${errors.email ? 'has-error' : ''}`}>
                            <label htmlFor="email">Email <span className="text-danger">*</span></label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                value={formData.email || ''}
                                onChange={this.handleInputChange}
                                placeholder="Enter Email"
                            />
                            {errors.email && <span className="help-block">{errors.email}</span>}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className={`form-group ${errors.group ? 'has-error' : ''}`}>
                            <label htmlFor="group">Roles <span className="text-danger">*</span></label>
                            <select
                                className="form-control"
                                id="group"
                                name="group"
                                value={formData.group || ''}
                                onChange={this.handleInputChange}
                            >
                                <option value="">Select a role</option>
                                {this.state?.rolesList?.map((role, index) => (
                                    <option key={"role" + index} value={role.groupName}>
                                        {role.groupName}
                                    </option>
                                ))}
                            </select>
                            {errors.group && <span className="help-block">{errors.group}</span>}
                        </div>
                    </div>
                    {
                        formData.group === "AgencyUser" && (
                            <>
                                <div className="col-lg-6">
                                    <div className={`form-group ${errors.organization ? 'has-error' : ''}`}>
                                        <label htmlFor="organization">Organization <span className="text-danger">*</span></label>
                                        <select
                                            className="form-control"
                                            id="organization"
                                            name="organization"
                                            value={this.state.formData.organization || ''}
                                            onChange={this.handleInputChange}
                                        >
                                            <option value="">Select a service organization</option>
                                            {this.state?.organizationList?.map((item, index) => (
                                                <option key={"organization" + index} value={item.name}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.organization && <span className="help-block">{errors.organization}</span>}
                                    </div>
                                </div>
                                {formData?.organization && (
                                    <div className="col-lg-6">
                                        <div className={`form-group ${errors.provider ? 'has-error' : ''}`}>
                                            <label htmlFor="provider">Service Provider(NPI) <span className="text-danger">*</span></label>
                                            <select
                                                className="form-control"
                                                id="provider"
                                                name="provider"
                                                value={this.state.formData.provider || ''}
                                                onChange={this.handleInputChange}
                                            >
                                                <option value="">Select a service provider</option>
                                                {this.state?.serviceProviderList?.map((item, index) => (
                                                    <option key={"provider" + index} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.provider && <span className="help-block">{errors.provider}</span>}
                                        </div>
                                    </div>
                                )}
                            </>
                        )
                    }
                </div>

                <div className="form-group sidebar-actions">
                    <button type="submit" className="btn btn-primary">
                        <i className="fa fa-save" /> Save
                    </button>
                    <button type="button" className="btn btn-default" onClick={this.props.onClose}>
                        <i className="fa fa-times" /> Cancel
                    </button>
                </div>
            </form >
        );
    };

    renderUserEditForm = () => {
        const { errors } = this.state;
        const { groups } = this.props;
        let groupName = this.props.selectedUser?.groups ? this.props.selectedUser.groups[0] : '';

        return (
            <form onSubmit={this.handleSubmit}>

                <div className={`form-group ${errors.group ? 'has-error' : ''}`}>
                    <label htmlFor="group">Roles <span className="text-danger">*</span></label>
                    <select
                        className="form-control"
                        id="group"
                        name="group"
                        value={this.state.formData.group || ""}
                        onChange={this.handleInputChange}
                    >
                        <option value="">Select a role</option>
                        {this.state?.rolesList?.map((role, index) => {
                            if (role?.groupName === "AgencyUser") return;
                            return (
                                <option key={"role" + index} value={role.groupName}>
                                    {role.groupName}
                                </option>
                            )
                        })}
                    </select>
                </div>

                {/* {
                    this.state.formData.group === "AgencyUser" && (
                        <div className={`form-group ${errors.provider ? 'has-error' : ''}`}>
                            <label htmlFor="provider">Service Provider(NPI) <span className="text-danger">*</span></label>
                            <select
                                className="form-control"
                                id="provider"
                                name="provider"
                                value={this.state.formData.provider || ''}
                                onChange={this.handleInputChange}
                            >
                                <option value="">Select a service provider</option>
                                {this.state?.serviceProviderList?.map((item, index) => (
                                    <option key={"provider" + index} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            {errors.provider && <span className="help-block">{errors.provider}</span>}
                        </div>
                    )
                } */}

                <div className="form-group sidebar-actions">
                    <button type="submit" className="btn btn-primary">
                        <i className="fa fa-save" /> Save
                    </button>
                    <button type="button" className="btn btn-default" onClick={this.props.onClose}>
                        <i className="fa fa-times" /> Cancel
                    </button>
                </div>
            </form>
        );
    };

    render() {
        const { isSidebarOpen, onClose, sidebarView } = this.props;

        if (!isSidebarOpen) return null;

        return (
            <div className="patient-sidebar-overlay" onClick={onClose}>
                <div className="patient-sidebar" onClick={e => e.stopPropagation()}>
                    {/* Header */}
                    <div className="sidebar-header">
                        <h4>{this.props.title}</h4>
                        <button className="close-btn" onClick={onClose}>
                            <i className="fa fa-times" />
                        </button>
                    </div>

                    {/* Form Content */}
                    <div className="sidebar-content">
                        {sidebarView === 'group' && this.renderRoleForm()}
                        {sidebarView === 'user' && this.renderUserForm()}
                        {sidebarView === 'userEdit' && this.renderUserEditForm()}
                    </div>
                </div>
            </div>
        );
    }
}
